import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { Roles } from '@/auth/azure/Roles'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import AbsenceAnomaliesPage from '@/routes/hours/anomalies/absences/AbsenceAnomaliesPage'
import { getPreviousMonth, toApiDate } from '@/routes/hours/anomalies/anomalies.utils'
import { RoleRoute } from '@/types'
import { faUmbrellaBeach } from '@fortawesome/free-solid-svg-icons'
import { AxiosResponse } from 'axios'
import { defer, LoaderFunction } from 'react-router-typesafe'

export type FluidaAbsenceIssueType = 'Missing' | 'DurationMismatch'
export type FluidaAbsenceCategory = 'Permit' | 'Holiday' | 'Mixed'
export type FluidaAbsenceAuthorization = 'Authorized' | 'RequestedNotAuthorized' | 'NotRequestedNotAuthorized' | 'Mixed'

export interface FluidaAbsenceCheckIssue {
  type: FluidaAbsenceIssueType
  contractId: string
  userId: number
  userName: string
  day: string
  category: FluidaAbsenceCategory
  authorization: FluidaAbsenceAuthorization
  expectedQsCostCenter: string
  actualQsCostCenter: string | null
  fluidaMinutes: number
  approvedRequestMinutes: number
  qsWebAdminMinutes: number
  minimumRequiredMinutes: number
  differenceMinutes: number
  missingMinutes: number
}

export interface FluidaAbsenceCheckContractFailure {
  contractId: string
  userEmail: string
  userName: string
  error: string
}

export interface FluidaAbsenceCheckResult {
  periodFrom: string
  periodTo: string
  status: 'Completed' | 'Incomplete'
  issues: FluidaAbsenceCheckIssue[]
  contractFailures: FluidaAbsenceCheckContractFailure[]
}

export const getFluidaAbsenceAnomalies = (from: Date, to: Date) =>
  useQsAdminApiManager
    .getState()
    .client.get<FluidaAbsenceCheckResult>(
      `api/attivitaLavorativa/fluidaabsenceanomalies?from=${toApiDate(from)}&to=${toApiDate(to)}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )

export const absenceAnomaliesPageRouteLoader = (async () => {
  const [minDate, maxDate] = getPreviousMonth()
  const getAbsenceAnomalies: Promise<AxiosResponse<FluidaAbsenceCheckResult, FluidaAbsenceCheckResult>> =
    getFluidaAbsenceAnomalies(minDate, maxDate)
  return defer({
    getAbsenceAnomalies,
    minDate,
    maxDate,
  })
}) satisfies LoaderFunction

export const AbsenceAnomaliesPageRoute = {
  path: 'absences',
  element: <AbsenceAnomaliesPage />,
  loader: absenceAnomaliesPageRouteLoader,
  errorElement: <RouterErrorHandler />,
  text: 'Assenze',
  faIcon: faUmbrellaBeach,
  handle: {
    crumb: () => ({
      label: 'Assenze',
    }),
  },
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
} satisfies RoleRoute
